import { useTranslation } from "react-i18next";

import { LinkButton } from "../../../components/LinkButton";
import { PMP_SUPPORT_URL } from "../../../constants/pMpConstants";
import { mixpanelActions } from "../../../utils/mixpanel";
import {
  FooterLinksContainerDesktop,
  FooterLinksContainerMobile,
} from "./FooterLinks.styles";

const footerLinks = [
  {
    name: "termsAndConditions",
    labelKey: "footer_termsAndConditions",
    url: "https://patientmpower.com/terms-of-use/",
    mixpanelAction: "UserAction: Clicked Terms and Conditions Link",
  },
  {
    name: "privayPolicy",
    labelKey: "footer_privacyPolicy",
    url: "https://patientmpower.com/privacy-policy/",
    mixpanelAction: "UserAction: Clicked Privacy Policy Link",
  },
  {
    name: "contactSupports",
    labelKey: "footer_contactSupport",
    url: PMP_SUPPORT_URL,
    mixpanelAction: "UserAction: Clicked Support Link",
  },
];

const handleOnClickOverFooterLinks = (currentLink: any) => {
  mixpanelActions.track(currentLink.mixpanelAction);
  window.open(currentLink.url, "_blank");
};

export function FooterLinksMobile() {
  const { t } = useTranslation();
  return (
    <FooterLinksContainerMobile>
      {footerLinks.map((currentLink) => (
        <LinkButton
          size="md"
          color="gray"
          fontWeight="bold"
          hoverColor="secondary"
          label={t(currentLink.labelKey)}
          key={currentLink.name}
          onClick={() => handleOnClickOverFooterLinks(currentLink)}
        />
      ))}
    </FooterLinksContainerMobile>
  );
}

export function FooterLinksDesktop() {
  const { t } = useTranslation();
  return (
    <FooterLinksContainerDesktop>
      {footerLinks.map((currentLink) => (
        <LinkButton
          size="md"
          color="gray"
          fontWeight="bold"
          hoverColor="secondary"
          label={t(currentLink.labelKey)}
          key={`${Math.random() * 1000}-${currentLink.name}`}
          onClick={() => handleOnClickOverFooterLinks(currentLink)}
        />
      ))}
    </FooterLinksContainerDesktop>
  );
}
